import { ResponseService } from './../services/response.service';
import { NotificationsService } from 'angular2-notifications';
import { element } from 'protractor';
import { ApiService } from './../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from './../services/local-storage.service';
import { ContractsService } from './../services/contracts.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-server-devices',
  templateUrl: './server-devices.component.html'
})
export class ServerDevicesComponent implements OnInit {
  public serverElement = <any>{};
  public loadingServerData: Boolean = true;

  constructor(
    private apiService: ApiService,
    private localStorageService: LocalStorageService,
    private notificationsService: NotificationsService,
    private responseService: ResponseService,
    private router: ActivatedRoute
  ) { }

  ngOnInit() {
    this.router.params.subscribe(params => {
      this.apiService.get('/company/' + this.localStorageService.get('company') + '/contract/' +
        params['id'] + '/item/' + params['server_id'] + '/element').subscribe(
          (response) => {
            const element = this.responseService.success(false, response, 'element');
            this.serverElement = element;
            this.loadingServerData = false;
          },
          (error) => {
            this.responseService.error(error);
          }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/server/server-devices.component.ts